import { AnimatedSection } from "./AnimatedSection";
import { AlertCircle } from "lucide-react";

const painPoints = [
  "You don't know if you're getting the right price",
  "Supply looks available but fails at execution",
  "Deals take too long to move from discussion to closure",
  "Everything happens across calls, emails, and messages",
];

export function PainPoints() {
  return (
    <section className="py-24 md:py-32 bg-[#050A07]" data-testid="pain-points-section">
      <div className="max-w-7xl mx-auto px-6">
        <AnimatedSection>
          <p className="text-[#22C55E] text-sm font-medium tracking-widest uppercase mb-4">
            The Real Pain
          </p>
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white max-w-3xl">
            If you are in trade, you already know this
          </h2>
        </AnimatedSection>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-4">
          {painPoints.map((point, i) => (
            <AnimatedSection key={i} delay={i * 0.1}>
              <div className="bg-[#09120D] border border-[#1A2E22] p-8 md:p-10 flex items-start gap-4 hover:border-[#EF4444]/30 transition-colors duration-300 group">
                <AlertCircle className="w-5 h-5 text-[#EF4444]/60 mt-0.5 flex-shrink-0 group-hover:text-[#EF4444] transition-colors" />
                <p className="text-[#A1B2A8] text-base leading-relaxed group-hover:text-white transition-colors">
                  {point}
                </p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
